<template>
    <div class="overview clearfix">
        <div class="right-col">
            <overview-right-account-info
              :overview-info="overviewInfo"
            ></overview-right-account-info>
        </div>
        <div class="left-col">
            <data-statistics-mam-master
                    :data-statistics="accountInfo"
            ></data-statistics-mam-master>

            <earnings-line-echart></earnings-line-echart>
            <order-list class="order-list"></order-list>
        </div>
        <share-btn
                @click.native="shareClickHandle"
                v-if="isShowShare"
        ></share-btn>
        <share-dialog
                ref="sharedialog"
        ></share-dialog>
    </div>
</template>

<script>

import {checkSharable, queryStatistics, queryStatisticsSimple} from '@/api/copy'
  import shareDialog from '@/components/common/shareDialog'
  import shareBtn from '@/components/common/shareBtn'
  import orderList from '@/components/user/details/common/order/orderList'
  import earningsLineEchart from '@/components/user/details/mamMaster/overview/earningsLineEchart'
    import accountIndexData from '@/components/common/accountIndexData'
    import overviewRightAccountInfo from '@/components/user/details/mamMaster/overview/overviewRightAccountInfo'

    import dataStatisticsMamMaster from '@/components/user/details/mamMaster/overview/dataStatistics/dataStatisticsMamMaster'
  export default {
    name: 'index',
    props: {
      overviewInfo: {
        type: Object,
        default() {
          return {}
        }
      },
    },
    components:{
      dataStatisticsMamMaster,
      earningsLineEchart,

      overviewRightAccountInfo,
      accountIndexData,
      shareBtn,
      shareDialog,
      orderList,
    },
    data() {
      return {
        accountInfo: {
          balance: 0,
          closeOrder: 3,
          createTime: "",
          credit: 0,
          earningRate: 0,
          enableReadOnly: 0,
          equity: 0,
          leverage: 0,
          login: 0,
          marginFree: 0,
          maxRetracement: 0,
          openOrder: 0,
          profitRate: 0,
          statProfit: 0,
          subLoginNumber: 1,
          times: 1,
        },
        isShowShare: false,
      };
    },
    created(){
      this.getShowShare();
      this.getStatisticsData();
    },
    methods: {
      getStatisticsData() {
        if(this.$route.name == 'mamMasterDetailsSimple' || this.$route.name == 'socialMasterDetailsSimple'){
          queryStatisticsSimple({
            mtId: this.$route.params.mtid,
          }).then((res) => {
            this.accountInfo = res.data[0];
          })
        }else {
          queryStatistics({
            mtId: this.$route.params.mtid,
          }).then((res) => {
            this.accountInfo = res.data[0];
          })
        }
      },
      getShowShare(){
        checkSharable({mtId: this.$route.params.mtid}).then((res) => {
          this.isShowShare = res.data;
        })
      },
      shareClickHandle(){
        this.$refs.sharedialog.shareDialogShow = true;
      },
    },
  };
</script>
<style lang="scss">

</style>
<style lang="scss" scoped>
.order-list {
  margin-top: 10px;
}
</style>
